"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { usePathname } from "next/navigation"

interface CookieConsentProps {
  enabled: boolean
  siteName: string
}

export default function CookieConsent({ enabled }: CookieConsentProps) {
  const [visible, setVisible] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    if (!enabled) return
    const stored = localStorage.getItem("cookie-consent")
    setVisible(stored !== "allow" && stored !== "reject")
  }, [enabled])

  if (!enabled || !visible || pathname.startsWith('/admin')) return null

  const accept = () => {
    localStorage.setItem("cookie-consent", "allow")
    setVisible(false)
  }
  const reject = () => {
    localStorage.setItem("cookie-consent", "reject")
    setVisible(false)
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-sm:left-4">
      <div className="w-[calc(100vw-2rem)] max-w-[380px] rounded-2xl border bg-card/95 backdrop-blur-sm text-card-foreground shadow-2xl">
        <div className="p-5">
          <h2 className="text-lg font-semibold tracking-wide">Privacy & Cookies</h2>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            We use essential cookies and browser storage for gallery access, preferences, carts, and selections. Optional first-party performance events help improve galleries and checkout. See our
            <Link href="/privacy" className="ml-1 font-medium underline">Privacy Policy</Link> for details.
          </p>
          <div className="mt-4 flex items-center gap-2">
            <button
              onClick={reject}
              className="inline-flex h-9 items-center justify-center rounded-md border bg-background px-3 text-sm font-medium hover:bg-muted"
            >
              Reject
            </button>
            <button
              onClick={accept}
              className="inline-flex h-9 items-center justify-center rounded-md bg-primary px-4 text-sm font-semibold text-primary-foreground hover:opacity-95"
            >
              Allow
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
